import axios from "axios";

const baseUrl = process.env.REACT_APP_API_BASE_URL || "";

export const getUserTimezone = (): string => {
  try {
    return Intl.DateTimeFormat().resolvedOptions().timeZone;
  } catch {
    return "UTC";
  }
};

export const verifyTicketStatusApi = async (data: {
  ticketId: string;
  userTimezone?: string;
  [key: string]: unknown;
}) => {
  try {
    const response = await axios.get(`${baseUrl}/user/payment/scan-ticket`, {
      params: {
        ...data,
        userTimezone: data.userTimezone ?? getUserTimezone(),
      },
    });
    return response;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log({ error });
    throw error;
  }
};
